export type HeroSlide = {
  id: string;
  image: string;
  eyebrow: string;
  tagline: string;
};

export const heroSlides: HeroSlide[] = [
  {
    id: "ht-001",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20documentary%20frame%20of%20a%20city%20boulevard%20at%20golden%20hour%20seen%20from%20a%20moving%20bus%2C%20deep%20navy%20blue%20shadows%20and%20warm%20amber%20sunlight%20streaks%2C%20soft%20motion%20blur%20of%20passersby%2C%20film%20grain%2C%20editorial%20mood%2C%20no%20text%2C%20dark%20enough%20for%20white%20overlay%20text%2C%20widescreen&width=1600&height=900&seq=hero-city-walk-01&orientation=landscape",
    eyebrow: "焦点推荐 · 人文纪录",
    tagline: "不带攻略，只凭一条公交线路走完一座城市。",
  },
  {
    id: "mv-003",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20sci-fi%20frame%20of%20a%20deep%20sea%20research%20station%20corridor%20with%20round%20portholes%20and%20cold%20navy%20blue%20underwater%20light%2C%20thin%20amber%20instrument%20glow%2C%20volumetric%20haze%2C%20film%20grain%2C%20suspenseful%20atmosphere%2C%20no%20text%2C%20dark%20tone%20suitable%20for%20overlay%20text%2C%20widescreen&width=1600&height=900&seq=hero-deep-sea-02&orientation=landscape",
    eyebrow: "焦点推荐 · 深海悬疑",
    tagline: "深海监测站收到一段不该存在的规律声波。",
  },
  {
    id: "mv-001",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20cinematic%20frame%20of%20an%20empty%20desert%20highway%20at%20late%20dusk%20with%20a%20single%20pair%20of%20headlights%2C%20vast%20deep%20navy%20blue%20sky%20and%20a%20thin%20warm%20amber%20horizon%2C%20lonely%20road%20movie%20mood%2C%20film%20grain%2C%20no%20text%2C%20dark%20cinematic%20grading%2C%20widescreen&width=1600&height=900&seq=hero-night-road-03&orientation=landscape",
    eyebrow: "焦点推荐 · 公路剧情",
    tagline: "三天两夜，两个人用零碎的对话拼出各自的过去。",
  },
  {
    id: "sh-003",
    image:
      "https://readdy.ai/api/search-image?query=Wide%20dreamy%20hand-drawn%20animation%20frame%20of%20a%20boy%20inside%20a%20giant%20glass%20bottle%20drifting%20on%20a%20calm%20night%20sea%2C%20deep%20navy%20blue%20water%20with%20warm%20amber%20sunset%20reflections%20and%20scattered%20stars%2C%20illustrated%20texture%2C%20no%20text%2C%20dark%20enough%20for%20white%20text%2C%20widescreen&width=1600&height=900&seq=hero-glass-sea-04&orientation=landscape",
    eyebrow: "焦点推荐 · 手绘动画",
    tagline: "把海的声音装进瓶子，寄给远方。",
  },
];